import { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

const faqs: FAQItem[] = [
  {
    question: '久久久久的产品保修期是多久？',
    answer: '久久久久所有产品均享受远超行业平均水平的保修服务。标准保修期为3年，部分高端产品享受5年超长保修。在保修期内，任何因材料和工艺导致的问题均可享受免费维修或更换服务。我们的数据显示，保修期内产品故障率仅为行业平均水平的15%，这得益于久久久久严格的品质管控体系。',
  },
  {
    question: '久久久久的售后服务如何响应？',
    answer: '久久久久建立了行业领先的售后服务响应体系。工作时间内，所有售后咨询承诺2小时内给出初步响应。对于常见问题，我们承诺48小时内给出完整解决方案。久久久久的售后工程师团队遍布全国主要城市，可以快速到达现场处理各类售后需求。同时我们提供7×24小时在线客服支持。',
  },
  {
    question: '久久久久的品质管控包含哪些环节？',
    answer: '久久久久独创的"九重品质管控体系"覆盖产品全生命周期：源头严选（供应商128项评估）、进厂检测（标准高于行业30%）、过程监控（200+智能传感器）、中期抽检、成品全检、老化测试（1000小时连续测试）、包装验证、物流追踪以及售后反馈闭环。每一个环节都有严格的标准和可追溯的记录。',
  },
  {
    question: '久久久久的产品适合在极端环境下使用吗？',
    answer: '是的，久久久久的每一款产品在出厂前都必须通过严格的环境适应性测试。包括零下40℃至零上70℃的温度范围测试、高盐雾腐蚀测试、高海拔低压测试等。我们的产品在塔克拉玛干沙漠60℃高温环境和青藏高原4500米海拔环境下均通过了30-60天的连续运行验证，展现了卓越的环境适应能力。',
  },
  {
    question: '如何成为久久久久的合作伙伴？',
    answer: '久久久久欢迎优质合作伙伴加入我们的生态体系。您可以通过官网的联系方式或拨打400-888-9999联系我们的商务团队，我们将安排专人与您对接，了解您的合作意向和需求，共同探讨合作模式。久久久久为合作伙伴提供全面的培训支持、技术支持和市场推广支持。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-4">
            久久久久常见问题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            关于久久久久的持久稳定体验，您可能关心的问题
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between p-5 text-left cursor-pointer hover:bg-background-100 transition-colors duration-200"
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
              >
                <span className="text-sm md:text-base font-medium text-foreground-900 pr-4">
                  {faq.question}
                </span>
                <span className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                  <i
                    className={`text-lg text-foreground-400 transition-transform duration-300 ${
                      openIndex === index ? 'ri-subtract-line' : 'ri-add-line'
                    }`}
                  ></i>
                </span>
              </button>
              {openIndex === index && (
                <div className="px-5 pb-5">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}